<template>
  <div class="review-wrapper">
    <div class="review-label d-flex align-items-center" @click="openReviewPopup">
      <div class="mr-3">Reviews</div>
      <div class="star-section">
        <div class="star-blank"><img src="https://tss-static-images.gumlet.io/star-blank.png" /></div>
        <div class="star-fill" :style="{ width: `${avgRating * 20}%` }"><img src="https://tss-static-images.gumlet.io/star-fill.png" /></div>
      </div>
    </div>
    <div>
      <transition name="slide-fade">
        <div class="review-listing-wrapper d-flex justify-content-end" v-if="showReviewPopup">
          <div class="review-listing">
            <div class="d-flex justify-content-between review-title-wrapper">
              <div class="review-listing-title">
                Reviews
              </div>
              <div class="cross-icon" @click="closeReviewPopup">
                  <!-- <i class="fa fa-times" aria-hidden="true"></i> -->
              </div>
            </div>
            <div class="review-listing-content custom-scrollbar">
              <div class="review-list" v-for="(rating, index) in getRatings" :key="index">
                <div class="d-flex">
                  <div class="star-section">
                    <div class="star-blank"><img src="https://tss-static-images.gumlet.io/star-blank.png" /></div>
                    <div class="star-fill" :style="{ width: `${rating.product_rating * 20}%` }"><img src="https://tss-static-images.gumlet.io/star-fill.png" /></div>
                  </div>
                  <div class="review-list-date">( {{ getDate(rating.rating_date) }} )</div>
                </div>
                <div class="review-list-title">
                  {{rating.rating_title}}
                </div>
                <div class="review-list-desc">
                  {{rating.rating_description}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import moment from 'moment/src/moment'
export default {
  props: ['avgRating', 'productId'],
  data () {
    return {
      showReviewPopup: false
    }
  },
  computed: {
    ...mapGetters({
      getRatings: 'getRatings'
    })
  },
  mounted () {
    this.$store.dispatch('FETCH_RATINGS', {id: this.productId})
  },
  methods: {
    openReviewPopup () {
      this.showReviewPopup = true
      const el = document.querySelector('body')
      el && el.classList.add('overflow-y-hidden')
    },
    closeReviewPopup () {
      this.showReviewPopup = false
      const el = document.querySelector('body')
      el && el.classList.remove('overflow-y-hidden')
    },
    getDate (date) {
      return moment(date).format('DD MMM YYYY')
    }
  }
}
</script>
<style scoped>
.cross-icon {
  cursor: pointer;
}
.cross-icon:after {
  display: inline-block;
  content: "\00d7";
  font-size: 38px;
  line-height: 38px;
}
.review-label {
  padding: 12px 15px;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #eee;
  position: relative;
  cursor: pointer;
}
.review-label:before {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: 22px;
  right: 15px;
  top: 15px;
  content: "\f107";
  position: absolute;
}
.review-listing-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  transition: 0.5s;
  overflow: hidden;
}
.review-listing-wrapper:before {
  height: 100%;
  width: 100%;
  display: block;
  content: '';
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
}
.review-listing {
  width: 450px;
  height: 100vh;
  padding: 15px;
  background: #fff;
  padding: 20px 0;
  position: relative;
}
.review-title-wrapper {
  padding: 0 28px 16px 40px;
}
.review-listing-content {
  padding: 0 28px 0 40px;
  max-height: calc(100vh - 95px);
  overflow-y: auto;
}
.review-list {
  margin-bottom: 20px;
}
.review-list:last-child {
  margin-bottom: 0;
}
.review-listing-title {
  font-size: 24px;
  font-weight: 600;
}

.review-list-title {
  font-size: 15px;
  color: #090913;
  margin: 14px 0 4px;
}
.review-list-desc {
  font-size: 15px;
  color: #6d7275;
}
.star-section {
  width: 114px;
  position: relative;
}
.star-fill {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
}
.star-fill img {
  max-width: 114px;
}
.review-list-date {
  font-size: 10px;
  color: #979a9f;
  margin: 4px 0 0 10px;
}

.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(0);
  opacity: 0;
}
.custom-scrollbar {
    scrollbar-width: 5px;
    scrollbar-color: #cccccc;
}
.custom-scrollbar::-webkit-scrollbar {
  width: 5px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #cccccc;
  border-radius: 10px;
}
@media screen and (max-width: 767px) {
  .review-listing-wrapper {
    align-items: flex-end;
  }
  .review-listing {
    width: 100%;
    height: 60vh;
    padding: 10px 0;
  }
  .review-title-wrapper {
    padding: 0 20px 12px;
  }
  .review-listing-title {
    font-size: 22px;
  }
  .review-listing-content {
    padding: 0 20px;
    max-height: calc(60vh - 75px);
  }
}
</style>



// WEBPACK FOOTER //
// reviewModal.vue?f6b44ca4